module.exports = __webpack_public_path__ + "static/media/results_open.89719b33.png";